import { render, staticRenderFns } from "./national-rehabilitation-centre.vue?vue&type=template&id=8d969474&"
import script from "./national-rehabilitation-centre.vue?vue&type=script&lang=js&"
export * from "./national-rehabilitation-centre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports